import React from "react";
import { connect } from 'react-redux';

import { FormControl, Input } from '@material-ui/core';

import { setSurveyAnswer } from '../../../actions/surveyActions';

class SurveyPageInputTypeQuestions extends React.Component {
    onAnswerChange(e) {
        let answer = e.target.value;

        if (this.props.surveyData.currentQuestionObject.type === "NUMBER") {
            !isNaN(answer) && this.props.setSurveyAnswer([answer]);
        } else {
            this.props.setSurveyAnswer([answer]);
        }
    }

    render() {
        return (
            <div className="survey-options-container">
                <FormControl classes={{ root: "survey-answer-input-wrapper", }}>
                    <Input
                        value={this.props.surveyData.currentAnswer ? this.props.surveyData.currentAnswer[0] : ''}
                        onChange={(e) => this.onAnswerChange(e)}
                        placeholder="Enter here"
                        classes={{input: "survey-answer-input", root: "survey-answer-input-outline", underline: "survey-answer-input-underline"}}
                    />
                </FormControl>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        surveyData : state.surveyData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSurveyAnswer: (ans) => {dispatch(setSurveyAnswer(ans))}
    }
}
    
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPageInputTypeQuestions);